import { Box, Button, Card, Collapse } from "@mui/material"
import InfoIcon from '@mui/icons-material/Info';
import { useLocation } from "react-router-dom";
import { useState } from "react";

export const InfoPanel = () => {

    const [open, setOpen] = useState(false);

    const location = useLocation();
    let text = 'Discover which items are trending and see what experiences people are sharing right now.';
    if (location.pathname.startsWith('/popular'))
    text = 'Discover which items are trending and see what experiences people are sharing right now.';
    if (location.pathname.startsWith('/activities'))
    text = 'Catch up on the latest activities from your friends and connections.';
    if (location.pathname.startsWith('/create-item'))
    text = 'Create a new item to share your experience with the community.';
    if (location.pathname.startsWith('/browse'))
    text = "Browse for items others have shared. If you can’t find what you’re looking for, go ahead and create it!";
    if (location.pathname.startsWith('/login'))
    text = 'Log in to access your items, friends, and experiences.';
    if (location.pathname.startsWith('/sign-up'))
    text = 'Sign up and start sharing your experiences today.';
    if (location.pathname.startsWith('/items/'))
    text = 'Explore details, stories, and experiences about this item.';
    if (location.pathname.startsWith('/user/'))
    text = 'Your shared experiences shape your profile and how others see you.';
    if (location.pathname.startsWith('/privacy'))
    text = 'How nosi.io collects, uses, and shares information.';
    if (location.pathname.startsWith('/admin'))
    text = 'Administration panel – manage users, items, and site settings.';
    if (/^\/user\/[a-z0-9-]+\/friends$/.test(location.pathname))
    text = 'See and manage your friends – the people you share experiences with most.';
    if (/^\/user\/[a-z0-9-]+\/settings$/.test(location.pathname))
    text = 'Update your profile, preferences, and account settings.';
    if (/^\/user\/[a-z0-9-]+\/followers$/.test(location.pathname))
    text = 'Check out who follows your experiences and updates.';

    return (
        <Box>
            <Button size="small" variant="text" startIcon={<InfoIcon />} onClick={() => setOpen(!open)} sx={{ color: 'appShell.chromeText' }}>Info</Button>
            <Collapse in={open}>
                <Card sx={{
                    borderRadius: '4px',
                    p: '4px',
                }}>
                    {text}
                </Card>
            </Collapse>
        </Box>
    );
}
